const stripPhoneScheme = (value: string) =>
  value
    .replace(/^(tel|sms):/i, '')
    .split(/[?#]/)[0]
    .trim();

export const normaliseAuPhoneNumber = (value?: string) => {
  const safeValue = stripPhoneScheme(value?.trim() || '');

  if (!safeValue) return '';

  const startsWithPlus = safeValue.startsWith('+');
  const digits = safeValue.replace(/\D/g, '');

  if (!digits) return '';

  if (startsWithPlus) return `+${digits}`;
  if (digits.startsWith('00')) return `+${digits.slice(2)}`;
  if (digits.startsWith('61')) return `+${digits}`;
  if (digits.startsWith('0')) return `+61${digits.slice(1)}`;

  return digits;
};

export const normaliseAuPhoneNumberForWhatsApp = (value?: string) =>
  normaliseAuPhoneNumber(value).replace(/^\+/, '');

export const buildTelHref = (value?: string) => {
  const phone = normaliseAuPhoneNumber(value);

  return phone ? `tel:${phone}` : '';
};

export const buildSmsHref = (value?: string, message?: string) => {
  const phone = normaliseAuPhoneNumber(value);

  if (!phone) return '';

  return `sms:${phone}${message ? `?&body=${encodeURIComponent(message)}` : ''}`;
};
